var md = new MobileDetect(window.navigator.userAgent);
		
if(md.mobile())
{
	var path = document.location.pathname.substring(1);
	var pathLast2Chars = path.substr(path.length - 2)
	var baseUrl = 'http://m.darwin6.com.br/#/';

	//var urlQueries = document.location.search;
	
	if(path && pathLast2Chars == '/p')
	{
		document.location.href = baseUrl + 'product/' + path.substring(0, path.length - 2);
	}
	else if(path)
	{
		document.location.href = baseUrl + 'search?keyword=' + path;
	}
	else
	{
		document.location.href = baseUrl;
	}
}